import { request } from '@umijs/max';
import type { deptmstr } from '@shenpu/shared-types';
import type {LoginParams,CurrentUser, ModifyPwdParams,buildJobSheet,Banzu,job,HeDao,WorkAddress,ModifyPwdAfterLoginParams ,AccessMenus,LoginResult,UserDetailList } from '@shenpu/shared-types'; 
import { result, UserDetail } from "@shenpu/shared-types";

export async function getDeptTree(): Promise<result> {
  return request<result>('/api/system/depttree', {
    method: 'GET'
  });
}

export async function addDept(dept: deptmstr): Promise<result> {
  return request<result>('/api/system/adddept', {
    method: 'POST',
    data: dept
  });
}

export async function deleteDept(deptid: number): Promise<result> {
  return request<result>('/api/system/deletedept', {
    method: 'DELETE',
    params: { deptid }
  });
}

export async function getDeptUsers(deptid: number): Promise<result> {
  return request<result>('/api/system/deptusers', {
    method: 'GET',
    params: { deptid }
  });
}

export async function addUserToDept(userid: string, deptid: number): Promise<result> {
  return request<result>('/api/system/addusertodept', {
    method: 'POST',
    params: { userid, deptid }
  });
}

export async function editDept(dept: deptmstr): Promise<result> {
  return request<result>('/api/system/editdept', {
    method: 'POST',
    data: dept
  });
}

export async function removeUserFromDept(userid: string, deptid: number): Promise<result> {
  return request<result>('/api/system/removeuserfromdept', {
    method: 'POST',
    params: { userid, deptid }
  });
}

export async function switchUser(userid:string,check:boolean)
{
  return request<result>('api/system/switchuser',{
    method:'Get',
    params:{
      userid:userid,
      check:check,
    }
  })
}



export async function userlist(options?: { [key: string]: any }){
  return request<UserDetailList>('/api/userlist',{
  method: 'GET',
  ...(options || {}),
  });
}

export async function addUser(userDetail:UserDetail)
{
  return request<result>('/api/system/adduser',{
    method:'POST',
    data:userDetail,
  })
}


export async function usermenulist(){
  //const userkey = localStorage.getItem('userkey');
  return request<AccessMenus>('/api/usermenulist',{
    method: 'GET',
    //params: { UserKey: userkey || '' },
  });
}


/** 获取菜单列表 POST /menulist */
export async function menulist(body?: { [key: string]: any }){
  return request<any>('/api/menulist',{
  method: 'POST',
  data: body || {},
  });
}

/** 保存用户菜单权限 POST /savemenulist */
export async function saveMenuList(body: { user_id: string; menu_paths: string[] }, options?: { [key: string]: any }){
  return request<any>('/api/savemenulist',{
  method: 'POST',
  data: body,
  ...(options || {}),
  });
}

export async function getmenulist()
{
  return request<result>('api/system/getmenulist',{
    method:'GET',
  })
}

export async function addmenu(menu: any): Promise<result> {
  return request<result>('/api/system/addmenu', {
    method: 'POST',
    data: menu
  });
}

export async function modifymenu(menu: any): Promise<result> {
  return request<result>('/api/system/modifymenu', {
    method: 'POST',
    data: menu
  });
}

export async function delmenu(menu_id: number): Promise<result> {
  return request<result>('/api/system/delmenu', {
    method: 'DELETE',
    params: { menu_id }
  });
}
export async function getpermissionlist(menupath:string):Promise<result>{
  return request<result>('api/system/getpermissionlist',{
    method:'GET',
    params:{
      menupath
    }
  })
}

export async function addpermission(menupath: string, userid: string): Promise<result> {
  return request<result>('/api/system/addpermission', {
    method: 'POST',
    data: { menupath, userid }
  });
}

export async function delpermission(menupath: string, userid: string): Promise<result> {
  return request<result>('/api/system/delpermission', {
    method: 'DELETE',
    params: { menupath, userid }
  });
}
